'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const fpe=require('pulsar-dashboard-core/dist-es6/extensions/fatiguePointExtensions');let

BiLevelLinePlotterDirective=class BiLevelLinePlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['points','threshold','dailyThresholds','ceiling','plotArea','verticalAxis','horizontalAxis','topStrokeWidth','bottomStrokeWidth'];
}
get textBindings(){
return['class','mask'];
}

get controller(){
return BiLevelLineController;
}};let


BiLevelLineController=class BiLevelLineController{
static get $inject(){
return['$scope'];
}

constructor($scope){
this._splitPoints=null;
this._ceiling=null;
this._$scope=$scope;

$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});
}

get _scalesValid(){
return(
_.exists(this.horizontalAxis)&&
_.exists(this.horizontalAxis.scale)&&
_.exists(this.verticalAxis)&&
_.exists(this.verticalAxis.scale));
}

redraw(){
if(!this._scalesValid){
return;
}

this._ceiling=this.verticalAxis.scale.invert(this.verticalAxis.offset+this.plotArea.axisLabelMargins.top+this.topStrokeWidth/2);

this._belowThresholdPoints=[];
this._atThresholdPoints=[];
this._aboveThresholdPoints=[];

for(const _ref of this.dailyThresholds){const{dayInterval,effectiveThreshold}=_ref;
const pointsInDay=this.points.filter(tsp=>dayInterval.contains(tsp.time));

const splitForDay=fpe(pointsInDay).splitByThresholds(effectiveThreshold);

_.pushMany(this._belowThresholdPoints,splitForDay.BelowOrNotApplicable);
_.pushMany(this._atThresholdPoints,splitForDay.At);
_.pushMany(this._aboveThresholdPoints,splitForDay.Above);
}

this._line=d3.svg.line().
interpolate('monotone').
x(point=>this.horizontalAxis.scale(point.time)).
y(point=>this.verticalAxis.scale(Math.min(point.value,this._ceiling))).
defined((point,i)=>!(isNaN(point.value)||point.notRendered));

this._group=d3.
select(this.plotArea.svgElement).
insert('g','.sleep').
attr({
class:`${this.class}`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


this._group.
append('rect').
attr({

height:'100%',
width:'100%',
fill:'none'});


this._drawPath(this.points,Math.max(this.bottomStrokeWidth,this.topStrokeWidth)+4,'stroke-outline');
this._drawPath(this._belowThresholdPoints,this.bottomStrokeWidth,'below-threshold bottom');
this._drawPath(this._atThresholdPoints,this.topStrokeWidth,'at-threshold top');
this._drawPath(this._aboveThresholdPoints,this.topStrokeWidth,'above-threshold top');
}

_drawPath(points,width,additionalClass){
this._group.
append('path').
attr({
class:additionalClass,
fill:'none',
"stroke-width":width,
d:this._line(points)});

}};


module.exports=BiLevelLinePlotterDirective;
//# sourceMappingURL=biLevelLinePlotterDirective.js.map
